// Hosted Beta — klien HTTP ke Central Worker backend.
// FAIL-CLOSED: bila VITE_HOSTED_BETA_API tak diset, semua panggilan throw (Hosted Beta mati di production).
// Corak auth = services/flowT2Admin.js (Bearer + getIdToken). uid dihantar melalui token (server sahkan).
import { auth } from '../firebase';

const HB_API = (import.meta.env.VITE_HOSTED_BETA_API || '').replace(/\/+$/, '');

/** Hosted Beta hanya boleh aktif bila backend dikonfigur (env diset) — pagar fail-closed. */
export const hostedBetaBolehAktif = () => !!HB_API;

async function panggil(path, body) {
  if (!HB_API) throw new Error('HOSTED_BETA_DISABLED'); // fail-closed
  await auth.authStateReady();
  if (!auth.currentUser) throw new Error('SILA_LOG_MASUK');
  const tok = await auth.currentUser.getIdToken();
  const r = await fetch(HB_API + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + tok },
    body: JSON.stringify(body || {}),
    credentials: 'omit', cache: 'no-store', signal: AbortSignal.timeout(30000),
  });
  const j = await r.json().catch(() => null);
  if (!r.ok) { const e = new Error((j && j.error) || ('HTTP_' + r.status)); e.status = r.status; throw e; }
  return j;
}

export const enqueueFlowJob = ({ productId, setKey, model, workflow, batchId }) => panggil('/enqueue', { productId, setKey, model, workflow, batchId });
export const bacaKuotaHostedBeta = () => panggil('/quota', {}); // pulang { used, cap, cards, cardCap, eligible }
export const bacaStatusHostedBeta = (productId) => panggil('/status', { productId });
// Batal job (hanya 'pending' — belum dihantar ke Google). Server pulang kuota bila selamat.
export const batalFlowJob = (jobId) => panggil('/cancel', { jobId });

// ── Batch manifest (notifikasi: satu Submit = satu batch = satu email ringkasan) ──
// buka SEBELUM enqueue (hantar niat penuh), seal SELEPAS semua enqueue (isyarat "tiada job lagi").
export const bukaBatchHostedBeta = (batchId, items) => panggil('/batch-open', { batchId, items });
export const sealBatchHostedBeta = (batchId) => panggil('/batch-seal', { batchId });

// ── Loceng notifikasi customer (milik UID sendiri — server sahkan token) ──
export const bacaNotifikasiHostedBeta = (limit) => panggil('/notifications', { limit }); // { notifications:[...] }
export const tandaNotifikasiDibaca = (notifId) => panggil('/notification-read', { notifId });

/** Semak backend hidup (untuk UI fail-closed). Pulang false jika tiada env / tak capai. */
export async function semakHealth() {
  if (!HB_API) return false;
  try { const r = await fetch(HB_API + '/health', { cache: 'no-store', signal: AbortSignal.timeout(5000) }); return r.ok; } catch { return false; }
}
